/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { CertificateSummary } from './CertificateSummary';

/**
 * A Device Make and Model combination
 */
export type MCCSummaryItem = {
	/**
	 * The meter case code
	 */
	meterCaseCode: string;
	/**
	 * The current meter case outcome
	 */
	meterCaseOutcome?: MCCSummaryItem.meterCaseOutcomeType;
	/**
	 * The name of the client
	 */
	clientName?: string;
	/**
	 * The type of device
	 */
	linkedForm?: CertificateSummary;
	/**
	 * The type of case
	 */
	caseType?: MCCSummaryItem.caseType;
};
export namespace MCCSummaryItem {
	/**
	 * The meter case outcome types
	 */
	export enum meterCaseOutcomeType {
		CONFORMING = 'Conforming',
		EXEMPT = 'Exempt',
		DISPOSED = 'Disposed',
		NON_CONFORMING = 'Non-conforming',
		CERTIFICATE = 'Certificate',
	}

	export enum caseType {
		NEW_METER = 'NewMeter',
		METER_VALIDATION = 'MeterValidation',
	}
}
